// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DespesasStatus_DeleteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/despesas_status/delete
 *
 * Deletes an expense status.
 */
import { registerContract } from './validate'

export interface DespesasStatus_DeleteInput {
despesa_status_id: number
}

registerContract('DespesasStatus_DeleteInput', {
  despesa_status_id: { type: 'number',  required: true },
})
